import React, { Component } from "react"
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import PlaidBankAccountForm from "./plaid.component.jsx"
import RainforestBankAccountWrapper from "./rainforest/RainforestBankAccountWrapper"

class BankAccountContainer extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            onSubmit: this.props.onSubmit || function () { },
            submitDisabled: this.props.submitDisabled,
            submitButton: this.props.submitButton,
            submitButtonStyle: this.props.submitButtonStyle,
            apiKey: this.props.apiKey,
            integrationKey: this.props.integrationKey,
            testMode: this.props.testMode,
            countryCode: this.props.countryCode,
            currency: this.props.currency,
            forceSaveBankAccount: this.props.forceSaveBankAccount || false,
            amount: this.props.amount,
            companyName: this.props.companyName,
            proposalHash: this.props.proposalHash,
            contactId: this.props.contactId
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            submitDisabled: nextProps.submitDisabled,
            apiKey: nextProps.apiKey,
            currency: nextProps.currency,
            amount: nextProps.amount,
            merchantId: nextProps.merchantId,
        })
    }

    render() {
        if (!this.state.apiKey || !this.state.integrationKey) {
            return <div />
        }
        switch (this.state.integrationKey) {
            case INTEGRATION_KEY.STRIPE:
                return (
                    <PlaidBankAccountForm
                        apiKey={this.state.apiKey}
                        proposalHash={this.state.proposalHash}
                        onSubmit={this.state.onSubmit}
                        submitButton={this.state.submitButton}
                        submitButtonStyle={this.state.submitButtonStyle}
                        submitDisabled={this.state.submitDisabled}
                        companyName={this.state.companyName}
                        currency={this.state.currency}
                        testMode={this.state.testMode}
                    >
                        {this.props.children}
                    </PlaidBankAccountForm>
                )
            case INTEGRATION_KEY.RAINFOREST:
                return (
                    <RainforestBankAccountWrapper
                        amount={this.state.amount}
                        buildMetaData={this.props.buildMetaData}
                        onClose={this.props.onClose}
                        proposalHash={this.props.proposalHash}
                        paymentAccount={this.props.paymentAccount}
                        forceSaveBankAccount={this.state.forceSaveBankAccount}
                    />
                )
            default:
                return <div />

        }
    }
}

export default BankAccountContainer





// WEBPACK FOOTER //
// ./src/common/bank-account/container.component.jsx